import Monitoring from '../components/pages/Monitoring/Monitoring'
import Data from '../components/pages/Monitoring/Data/Data'
import Connections from '../components/pages/Monitoring/Connections/Connections'

const ConnectionsFilters = () => import('../components/pages/Monitoring/Connections/ConnectionsFilters')
const DataFilters = () => import('../components/pages/Monitoring/Data/DataFilters')
const ConnectionsData = () => import('../components/pages/Monitoring/Connections/ConnectionsData/DataTable')
const ConnectionsVideos = () => import('../components/pages/Monitoring/Connections/ConnectionsVideos/ConnectionsTable')
const ConnectionsVideosHead = () => import('../components/pages/Monitoring/TableHeads/ConnectionsVideosHead.vue')
const MonitoringDataHead = () => import('../components/pages/Monitoring/TableHeads/DataTableHead.vue')

export default [
  {
    path: '/monitoring',
    name: 'monitoring',
    component: Monitoring,
    children: [
      {
        path: 'connections',
        name: 'monitoring.connections',
        components: {
          default: Connections,
          filters: ConnectionsFilters,
          tableHead: ConnectionsVideosHead
        },
        redirect: {
          name: 'connections.data'
        },
        children: [
          {
            path: 'data',
            name: 'connections.data',
            component: ConnectionsData
          },
          {
            path: 'videos',
            name: 'connections.videos',
            component: ConnectionsVideos
          }
        ]
      },
      {
        path: 'data',
        name: 'monitoring.data',
        components: {
          default: Data,
          filters: DataFilters,
          tableHead: MonitoringDataHead
        }
      }
    ]
  }
]
